import axios from 'axios';

export default {
    listProductListsByProduct(productId) {
        return axios.get('[API]/productlist/list-by-product/' + productId);
    },
    fetchDetails(nr) {
        return axios.get('[API]/productlist/fetch/' + nr);
    },
    remove(nr) {
        return axios.delete('[API]/productlist/delete/' + nr);
    },
    updateSawnForRecord(recordId, sawn) {
        return axios.post('[API]/productlist-record/update-sawn/' + recordId, {
            sawn,
        });
    },
    overview(payload) {
        return axios.post('[API]/productlist/overview', payload);
    },
};
